import AsyncSelect from "react-select/async";

import { MemberSearchProps } from "@models/shared/shared.model";

const MemberSearch = ({
  clearError,
  clubFilterList,
  filterByClubMembers = false,
  filteredClub,
  loadOptions,
  memberTitle,
  noOptionsMessage,
  onChangeGuest,
  placeholder,
  selectedGuest,
  setFilteredClub,
}: MemberSearchProps) => {
  const renderTabs = () => {
    return clubFilterList?.map((tab: { id: string; label: string }) => (
      <li
        key={tab.id}
        className={filteredClub === tab.id ? "fg-loc-active" : ""}
      >
        <button
          type="button"
          onClick={() => {
            setFilteredClub?.(tab.id);
            onChangeGuest(null);
            clearError();
          }}
        >
          {tab.label}
        </button>
      </li>
    ));
  };
  return (
    <div
      className="fg-member-search-section"
      data-testid="member-search-section"
    >
      {filterByClubMembers && (
        <div className="fg-location-block p-0">
          <ul className="fg-loc-scroll w-auto">{renderTabs()}</ul>
        </div>
      )}

      {memberTitle || null}

      <AsyncSelect
        loadOptions={loadOptions}
        placeholder={placeholder}
        noOptionsMessage={() => noOptionsMessage}
        className="mb-3 text-start"
        isClearable
        components={{
          DropdownIndicator: () => null,
          IndicatorSeparator: () => null,
        }}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: base => ({
            ...base,
            zIndex: 1090,
          }),
        }}
        value={selectedGuest}
        onChange={guest => {
          onChangeGuest(guest);
          clearError();
        }}
        onInputChange={(inputValue, { action }) => {
          if (action === "input-change") {
            clearError();
          }
          return inputValue;
        }}
      />
    </div>
  );
};

export default MemberSearch;
